module.exports = __webpack_public_path__ + "static/media/siddharth-chikmagalur-trip-02.d65915f9.png";